/* eslint-disable you-dont-need-momentjs/is-same */
/* eslint-disable you-dont-need-momentjs/no-moment-constructor */
/* eslint-disable no-param-reassign */
import moment from 'moment'

import {
  addDaysToDate,
  addWorkingDays,
  getNextWorkingDay,
  getWeekendDays,
  ISO_8601_DATE_FORMAT,
  WIZARD_DATE_FORMAT,
} from 'utils/dateUtils'
import {
  dateByFormat as dateByFormatValidation,
  dateMinRange as dateMinRangeValidation,
  required as requiredValidation,
  timeInFuture as timeInFutureValidation,
  validateAll,
} from 'utils/validations'

import { FULL_YEAR_DAYS, MINIMUM_COLLECTION_PERIOD, YEAR_WORK_DAYS } from '../steps/constants'

import { DEFAULT_COLLECTION_PERIOD, DEFAULT_REMINDERS_INTERVAL } from './constants'

const stateToProperties = (state) => ({
  launchDate: state.campaign.launchDate,
  launchTime: state.campaign.launchTime,
  closeTime: state.campaign.closeTime,
  randomized: state.campaign.randomized,
  participantsCount: state.campaign.participants.meta.count,
  messageStep: state.campaign.messageStep,
})

const calculateCampaignLaunchProperties = ({
  values,
  previousValues,
  workdays,
  isLaunchMethodNewHire = false,
}) => {
  const weekendDays = workdays === 3 ? [] : getWeekendDays(workdays)
  const mNow = moment()
  const mLaunchDate = moment(values.launchDate)
  const mCloseTime = moment(values.closeTime)
  const isLaunchDateValid = moment(values.launchDate, WIZARD_DATE_FORMAT, true).isValid()
  const isCloseTimeValid = moment(values.closeTime, WIZARD_DATE_FORMAT, true).isValid()
  const launchDateHasChanged = values.launchDate !== previousValues.launchDate
  const closeTimeHasChanged = values.closeTime !== previousValues.closeTime

  if (launchDateHasChanged || closeTimeHasChanged) {
    values.sendReminderEveryXBusinessDays = DEFAULT_REMINDERS_INTERVAL
  }

  // determinate single format
  if (isLaunchDateValid) values.launchDate = mLaunchDate.format(WIZARD_DATE_FORMAT)
  if (isCloseTimeValid) values.closeTime = mCloseTime.format(WIZARD_DATE_FORMAT)

  values.randomized = values.randomized || false

  const isLaunchToday = mLaunchDate.isSame(mNow, 'day')
  const isLaunchBefore = mLaunchDate.isBefore(mNow)
  const launchDateChanged = values.launchDate !== previousValues.launchDate

  if (values.launchDate && isLaunchDateValid) {
    if (launchDateChanged) {
      if (isLaunchBefore && !isLaunchToday) {
        values.launchDate = getNextWorkingDay(mNow.clone(), weekendDays).format(WIZARD_DATE_FORMAT)
      } else if (weekendDays.includes(mLaunchDate.day())) {
        values.launchDate = getNextWorkingDay(mLaunchDate.clone(), weekendDays).format(
          WIZARD_DATE_FORMAT
        )
      }
    }
  }

  if (launchDateHasChanged) {
    const daysToAdd = weekendDays.length ? YEAR_WORK_DAYS : FULL_YEAR_DAYS
    const closeTime = isLaunchMethodNewHire
      ? addWorkingDays(mLaunchDate.clone(), daysToAdd, weekendDays).format(WIZARD_DATE_FORMAT)
      : addDaysToDate(values.launchDate, DEFAULT_COLLECTION_PERIOD, true)

    values.closeTime = closeTime
  }

  if (values.randomized) {
    values.launchTime = '09:00'
  } else if (previousValues.randomized && !values.randomized) {
    values.launchTime = ''
  }

  return values
}

export const getTrainingCampaignLaunchProperties = (state, propertiesToSwap) =>
  calculateCampaignLaunchProperties({
    values: { ...stateToProperties(state), ...propertiesToSwap },
    previousValues: stateToProperties(state),
    workdays: state.workdays,
    isLaunchMethodNewHire: !!state.campaign.triggerBasedCampaignData,
  })

export const mapTrainingValidatorByName = {
  name: (field) => requiredValidation(field),
  launchDate: (field) => dateByFormatValidation(field, WIZARD_DATE_FORMAT),
  closeTime: (field, launchDate) =>
    validateAll([
      dateByFormatValidation(field, WIZARD_DATE_FORMAT),
      dateMinRangeValidation(launchDate, field, MINIMUM_COLLECTION_PERIOD),
    ]),
  launchTime: (field, launchDate, tz, randomized) =>
    randomized
      ? undefined
      : validateAll([
          requiredValidation(field),
          timeInFutureValidation(new Date(`${launchDate} ${field}`), tz),
        ]),
  sendRemindersUntil: (field) => dateByFormatValidation(field, ISO_8601_DATE_FORMAT),
}
